// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__N_6rQ","paramInput":"JobSimulator_paramInput__2JQhe","input":"JobSimulator_input__1ieSt"};